import { Routes } from '@angular/router';
import { cmsArrayToObj } from './service/cms-widgets';
import { CmsGeneratorComponent } from './cms-generator/cms-generator.component';
export const routes = [
    { path: '', component: CmsGeneratorComponent }
];
const ɵ0 = cmsArrayToObj;
export class CmsGeneratorModule {
}
export { ɵ0 };
